import DataAutofillSelect from "@/components/input/DataAutofillSelect";
import MultiSelect from "@/components/input/MultiSelect";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  handleFormChange,
  mergeDateAndTime,
  submitCreateForm,
} from "@/utils/formChange";
import { formInterface } from "@/interface/dataInterface";
import { User, Car, Calendar1 } from "lucide-react";
import { FC, FormEvent } from "react";
import FormWizard from "react-form-wizard-component";
import ClientFormCommon from "@/components/common/form/ClientForm";
import VehicleFormCommon from "@/components/common/form/VehicleForm";
import { toast } from "sonner";
import CreateWizardCommon from "@/components/common/CreateWizard";
import {
  BaseStaticSelect,
  BaseTextArea,
  DateAndTime,
} from "@/components/input/CustomInputs";
import InventoryTable from "../InventoryTable";
import { useRefresh } from "react-admin";

const InvoiceForm: FC<formInterface> = ({
  mode,
  formProp,
  setFormProp,
  otherData,
  setOtherData,
}) => {
  const refresh = useRefresh();
  const {
    name,
    email,
    phone,
    vin,
    make,
    model,
    year,
    license_plate,
    date,
    time,
    notes,
    payment,
    invoice_items,
    total,
  } = formProp;

  const submitForm = () => {
    if (invoice_items.length === 0) {
      toast("At least 1 service must be selected");
      return;
    }

    submitCreateForm(
      "auto-service-invoices",
      {
        client: { name, email, phone },
        vehicle: { make, model, year, vin, license_plate },
        date: mergeDateAndTime(date, time),
        notes,
        total,
        payment,
        status: "Unpaid",
        invoice_items,
      },
      refresh,
    );
  };

  return (
    <CreateWizardCommon
      title="invoice"
      confirmForm={submitForm}
      buttonTitle="Generate new invoice"
    >
      <FormWizard.TabContent title="Client details" icon={<User />}>
        <div>
          <div className="my-3 flex items-center justify-between">
            <Label>Existing client? Import</Label>
            <DataAutofillSelect
              formProp={{ name, email, phone }}
              setFormProp={setFormProp}
              resource="auto-service/clients"
              prop="email"
            />
          </div>
          <form className="reservation-form-step">
            <ClientFormCommon
              formProp={{ name, email, phone }}
              setFormProp={setFormProp}
            />
          </form>
        </div>
      </FormWizard.TabContent>
      <FormWizard.TabContent title="Vehicle Info" icon={<Car />}>
        <div className="mt-5">
          <div className="my-3 flex items-center justify-between">
            <Label>Existing vehicle? Import</Label>
            <DataAutofillSelect
              formProp={{ vin, make, model, license_plate, year }}
              setFormProp={setFormProp}
              resource="auto-service/vehicles"
              prop="license_plate"
            />
          </div>
          <form className="reservation-form-step">
            <VehicleFormCommon
              formProp={{ vin, make, model, year, license_plate }}
              setFormProp={setFormProp}
            />
          </form>
        </div>
      </FormWizard.TabContent>
      <FormWizard.TabContent title="Invoice details" icon={<Calendar1 />}>
        <form className="reservation-form-step">
          <div className="grid min-[550px]:grid-cols-2 gap-5">
            <DateAndTime formProp={formProp} setFormProp={setFormProp} />
            <div className="grid gap-1">
              <Label htmlFor="payment" className="text-right">
                Payment method *
              </Label>
              <Input
                id="payment"
                name="payment"
                type="text"
                value={formProp.payment}
                onChange={(e: FormEvent<HTMLInputElement>) =>
                  handleFormChange(e, setFormProp)
                }
                placeholder="Payment"
                required
              />
            </div>
            <div className="w-full grid gap-1">
              <Label htmlFor="service" className="text-right">
                Parts *
              </Label>
              <MultiSelect
                resource="auto-service-inventory"
                selected={otherData || []}
                setSelected={setOtherData || (() => {})}
                dataProp="name"
                objectProps={["name", "price", "unit"]}
              />
            </div>
            {mode === "edit" && (
              <BaseStaticSelect
                id="status"
                label="Status"
                value={formProp.status}
                setValue={setFormProp}
                data={[{ label: "Paid" }, { label: "Unpaid" }]}
              />
            )}
            {/* <div className="w-full grid gap-1">
              <Label htmlFor="service" className="text-right">
                Services *
              </Label>
              <MultiSelect
                resource="auto-service"
                selected={otherData || []}
                setSelected={setOtherData || (() => {})}
                dataProp="title"
                objectProps={["title", "price"]}
              />
            </div> */}
            <div className="min-[550px]:col-span-2">
              <BaseTextArea
                id="notes"
                label="Notes"
                value={formProp.notes}
                setProp={setFormProp}
              />
            </div>
          </div>
        </form>
        <InventoryTable
          data={otherData || []}
          setData={setOtherData || (() => {})}
        />
      </FormWizard.TabContent>
    </CreateWizardCommon>
  );
};

export default InvoiceForm;
